import React from "react"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import "./RichTextEditor.scss"
const RichTextEditor = ({ value, setValue, id }) => {
  return (
    <div className="comment-text-editor">
      <ReactQuill
        id={id}
        modules={RichTextEditor.modules}
        formats={RichTextEditor.formats}
        style={{
          height: "80%",
          fontSize: 12,
        }}
        theme="snow"
        value={value}
        onChange={setValue}
      />
    </div>
  )
}

export default RichTextEditor

RichTextEditor.modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
  ],
  clipboard: {
    matchVisual: false,
  },
}

RichTextEditor.formats = ["bold", "italic", "underline", "list", "bullet"]
